import { lowerCase } from 'lodash';
import { Addon } from '../components/Inputs/TextInput/TextInput';

export const getParameterByName = (name: string) => {
  const match = RegExp(`[?&]${name}=([^&]*)`).exec(window.location.search);
  return match && decodeURIComponent(match[1].replace(/\+/g, ' '));
};

export const isTesting = getParameterByName('testTags') === 'true';

export const renderDataTest = (shouldRender: boolean) => (tag: string) => shouldRender && { 'data-test': tag };

export const parseOption = (option: string) => {
  if (option === Addon.Percentage) {
    return 'percentage';
  }

  if (option === Addon.Pound) {
    return 'pound';
  }

  return lowerCase(option).split(' ').join('-');
};

export const buildDataTest = (dataTest = { isTesting: false, tag: '' }, option: string) =>
  dataTest.isTesting && { 'data-test': `${dataTest.tag}-${parseOption(option)}` };

export interface DataTest {
  dataTest?: false | { 'data-test': string; };
}

export interface DataTestObject {
  isTesting: boolean;
  tag: string;
}



// WEBPACK FOOTER //
// ./src/utilities/testAutomation.ts